import { createFileRoute } from '@tanstack/react-router';
import { CobrancaBoleto } from '@/features/cobranca-boleto/page';

export const Route = createFileRoute('/a/cobranca-boleto/')({
    component: CobrancaBoleto,
});
